import { render, staticRenderFns } from "./GradeFeeImport.vue?vue&type=template&id=28f3eb24"
import script from "@/controllers/custom/grade_fee/grade-fee-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/grade_fee/grade-fee-import.js?vue&type=script&lang=js&external"
import style0 from "./GradeFeeImport.vue?vue&type=style&index=0&id=28f3eb24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports